export default __webpack_public_path__ + "static/media/833.6547b967.png";